/**
 * Hiyerarşik kategorileri açılır menü için düz bir diziye dönüştürür
 *
 * @param {Array} categories - API'den gelen ham kategoriler
 * @param {Number} level - Mevcut iç içe geçme seviyesi
 * @param {Array} result - Sonuçlar için toplayıcı
 * @returns {Array} - Açılır menü için işlenmiş kategoriler
 */
export const processCategories = (categories, level = 0, result = []) => {
  if (!categories || !Array.isArray(categories)) {
    return []
  }

  categories.forEach(category => {
    // Mevcut kategoriyi ekle
    const prefix = level > 0 ? '—'.repeat(level) + ' ' : ''
    result.push({
      value: category.id,
      label: prefix + category.name,
      level: category.level,
      // Hata ayıklama için rawData ekle
      rawData: category,
    })

    // Alt kategorileri tekrarlayarak işle
    if (category.children && category.children.length > 0) {
      processCategories(category.children, level + 1, result)
    }
  })

  return result
}